module.exports = __webpack_public_path__ + "img/657274_2A2F30_A0A7B0_363C44-256px.6505605f.png";